<template>
  <sidebar dir="rtl"/>
  <div class="container mt-5" dir="rtl">
    <div class="card-panel-main col-lg-9 p-4 mb-5" style="transform: translateX(-19vw)">
      <div class=" p-3 card card-body card-panel-box border-0">
    <JobForm />
      </div>
      </div>
  </div>
</template>

<script>
import JobForm from '@/components/JobDescription/JobForm.vue'
import Sidebar from "@/components/Sidebar/Sidebar.vue";

export default {
  components: {
    Sidebar,
    JobForm
  }
}
</script>
<style scoped lang="scss">
.card {
  border-radius: 1.5vw;
}

.card-header {
  border-top-left-radius: 1.5vw;
  border-top-right-radius: 1.5vw;
  background: #3742FA !important;
  /*text-align: right;*/
  /*background: none !important;*/
  text-align: center;
  padding: 1vw !important;
}

.card-header h4 {
  font-size: 1.2vw !important;
  color: white;
}

.card-header {
  border-radius: .9vw .9vw 0 0 !important;
}

.btn-success, .btn-outline-primary {
  font-size: 1.8vw;
  font-weight: bold;
}

.btn-success .fas, .btn-outline-primary .fas {
  font-size: 1.5vw;
}

textarea {
  resize: none;
  /*min-height: 3rem !important;*/
  min-height: 2.8vw !important;
}

.v-select {
  direction: rtl;
  font-size: .9vw !important;
}

.vs__selected-options {
  /*overflow: hidden;*/
  width: 12vw;
}

.vs__selected-options .vs__search {
  margin: 0 !important;
  font-size: .9vw !important;
  color: #8C91F2 !important;
}

.vs__selected {
  font-size: .9vw !important;
  color: #8C91F2 !important;
  font-weight: 700;
  width: auto;
}

.vs__actions {
  width: 1.7vw;
}

.nowrap {
  white-space: nowrap;
}

h1 {
  font-size: 1.5vw !important;
  color: white !important;
}

h4 {
  font-size: 1.2vw !important;
  color: white !important;

}

h5 {
  font-size: 1.1vw !important;
  color: white !important;

}

p {
  font-size: 1vw;
}

.fs-sm {
  font-size: .9vw !important;
}

.form-label {
  margin-bottom: .5vw;
  font-size: .85vw !important;
}

th, td {
  vertical-align: middle;
  text-justify: inter-word;
}

th {
  text-align: center;
}

.btn.btn-sm {
  font-size: 1.2vw !important;
}

.btn-primary {
  color: white;
  background: #3742FA;
}

.btn-primary:hover {
  color: inherit;
}

.custom-p-2 {
  padding: 1.2vw !important;
}

.btn-add {
  font-size: 1.8vw !important;
  padding: 0.5vw 0 .2vw !important;
}

tr:nth-child(odd) {
  background: #86D1FE;
}

tr:nth-child(even) {
  background: #BDE6FF;
}

.vw-8 {
  width: 8vw;
}

.job-professional-row {
  display: grid;
  grid-template-columns: repeat(4, 2fr) 1fr;
  gap: 0.8vw;
  align-items: end;
}

.study-row {
  display: grid;
  grid-template-columns: repeat(3, 2fr) 1fr;
  gap: 0.8vw;
  align-items: end;
}

.duty-row {
  display: grid;
  grid-template-columns: repeat(5, 2fr) 1fr;
  gap: 0.8vw;
  align-items: end;
}

.responsibility-row {
  display: grid;
  grid-template-columns: repeat(2, 3fr) 2fr 1fr;
  gap: 0.8vw;
  align-items: end;
}

.rule-row {
  display: grid;
  grid-template-columns: repeat(3, 2fr) 1fr;
  gap: 0.8vw;
  align-items: end;
}

.progress-bar-height {
  height: 2.3vw;
}

.rounded {
  border-radius: .5vw !important;
}

.my-5 {
  margin: 3vw 0 !important;
}

</style>